import React from 'react';
import { motion } from 'framer-motion';

const Formtxt = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 1.2 }}
      viewport={{ once: false, amount: 0.3 }}
      className="bg-white py-20 px-6"
    >
      <div className="max-w-4xl mx-auto text-center">
         <p className="text-gray-700 text-base sm:text-lg leading-relaxed"
  style={{ fontSize: '16px' }}>
          Tell us your travel dates, interests, and riding experience—we’ll tailor a journey just for you. 
          Whether it’s your first ride or your hundredth, Ashwalaya welcomes you home to the saddle.
        </p>
      </div>
    </motion.section>
  );
};

export default Formtxt;
